export default {
  topics: [],
  accountSettings: ''
}
